import { atom } from "jotai";

import { contactAddressModalAtom } from "./contactAddressState";

export const isContactAddressVisibleAtom = atom(
  (get) => get(contactAddressModalAtom).isVisible,
  (_get, set, value: boolean) => {
    set(contactAddressModalAtom, (draft) => {
      draft.isVisible = value;
    });
  },
);

export const contactAddressContactIdAtom = atom(
  (get) => get(contactAddressModalAtom).contactId,
);

export const contactAddressDefaultPlaceAtom = atom(
  (get) => get(contactAddressModalAtom).defaultPlace,
);

export const contactAddressCreateNewAtom = atom(
  (get) => get(contactAddressModalAtom).createNew,
  (_get, set, value: boolean) => {
    set(contactAddressModalAtom, (draft) => {
      draft.createNew = value;
    });
  },
);

export const showContactAddressAtom = atom(
  null,
  (_get, set, contactId: number | null = null, place: string = "") => {
    set(contactAddressModalAtom, (draft) => {
      draft.isVisible = true;
      draft.contactId = contactId;
      draft.defaultPlace = place;
      // Default on for a fixed contact, off for the contact picker — the
      // user can still toggle it either way afterwards.
      draft.createNew = contactId != null;
    });
  },
);

export const hideContactAddressAtom = atom(null, (_get, set) => {
  set(isContactAddressVisibleAtom, false);
});
